export default __webpack_public_path__ + "static/media/coil_stapel.6075da53.png";